export const code = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.5 4.5L4.5 3.5H10.5V5.5H5.5V22.5H10.5V24.5H4.5L3.5 23.5V4.5ZM17.5 3.5H23.5L24.5 4.5V23.5L23.5 24.5H17.5V22.5H22.5V5.5H17.5V3.5ZM17 19H16.5L16.2 18.6L14 15.6667L11.8 18.6L11.5 19H11H10C9.17157 19 8.5 18.3284 8.5 17.5C8.5 16.6716 9.17157 16 10 16C10.3737 16 10.7154 16.1366 10.978 16.3626L12.75 14L10.5 11L9 11V9H11H11.5L11.8 9.4L14 12.3333L16.2 9.4L16.5 9H17H18C18.8284 9 19.5 9.67157 19.5 10.5C19.5 11.3284 18.8284 12 18 12C17.6263 12 17.2846 11.8634 17.022 11.6374L15.25 14L17.5 17H19V19H17Z"
    fill="currentColor"
  />
);
